export default __webpack_public_path__ + "static/media/1930.1aa815a6.png";